import { useLocalStorageState } from './useLocalStorageState';

const STORAGE_KEY = 'matchiGridShowMachine';
const DEFAULT_VALUE = false;

export const useShowMachine = () => {
	const [showMachine, setShowMachine] = useLocalStorageState(STORAGE_KEY, DEFAULT_VALUE);
	return { showMachine, setShowMachine };
};
